import Navbar from "./components/Navbar/Navbar";
import { BrowserRouter as Router } from 'react-router-dom'
import Hero from "./components/Hero/Hero";
import Project from "./components/Project/Project";
import AboutUs from "./components/AboutUs/AboutUs";
import Footer from "./components/Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react'

function App() {
  useEffect(() => {
    AOS.init({
      once: true
    })
  },[])
  return (
    <Router>
      <Navbar />
      <Hero />
      <Project />
      <AboutUs />
      <Footer />
    </Router>
  );
}

export default App;
